import React from "react";
import {
  TextInput,
  Filter,
  RefreshButton,
  CreateButton,
  SelectInput,
  ReferenceInput,
  ReferenceArrayInput,
} from "admin-on-rest";
import SelectProductArrayInput from "./SelectProductArrayInput";
import { CardActions } from "material-ui/Card";
import { styles } from "./styles";
import ImportProductButton from "./ImportProductButton";

export const toolbar = [
  [{ header: [1, 2, 3] }],
  ["bold", "italic", "underline", "strike"],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ color: [] }, { background: [] }],
  ["image", "code-block"],
];

export const creaditMode = [
  { id: "credit_card", name: "Credit Card" },
  { id: "bank_transfer", name: "Bank Transfer" },
];

//export const productDefaultValue = { variant: { options: [] }, active: false, payment: { installment: false } };

export const productDefaultValue = {
  variant: { options: [] },
  sort_order: 1,
  photos: {},
  name: "",
  partner_margin: 0,
  payment: {
    enabled_payments: ["credit_card", "bank_transfer"],
  },
  payment_mode_id: 1,
  shipping: {
    weight: 1,
    subsidy: 0,
  },
};

export const validateProductCreate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = ["Name is required"];
  }
  if (!values.brand) {
    errors.brand = ["Brand is required"];
  }
  if (!values.slug) {
    errors.slug = ["Slug is required"];
  }
  if (!values.payment_mode_id) {
    errors.payment_mode_id = ["Payment Mode is required"];
  }

  //remove validation because optional side group
  // if (!values.tags || !values.tags.length) {
  //   errors.tags = ["Tags is required"];
  // }

  if (!values.category_id) {
    errors.category_id = ["Category is required"];
  }
  //remove validation because optional side group
  // if (!values.collections || !values.collections.length) {
  //   errors.collections = ["Collections is required"];
  // }

  if (!values.variant.options || !values.variant.options.length) {
    errors.variant = {
      options: { _error: "At least one Options must be entered" },
    };
  } else {
    const optionsArrayErrors = [];
    values.variant.options.forEach((option, optionIndex) => {
      const optionErrors = {};
      if (!option || !option.name) {
        optionErrors.name = "Required";
        optionsArrayErrors[optionIndex] = optionErrors;
      }
      if (!option || !option.values) {
        optionErrors.values = "Required";
        optionsArrayErrors[optionIndex] = optionErrors;
      }
      if (option && option.values && option.values.length) {
        const valuesArrayErrors = [];
        option.values.forEach((value, valueIndex) => {
          if (!value || !value.length) {
            // console.log(value);
            // console.log(value.length);
            valuesArrayErrors[valueIndex] = "Required";
          }
        });

        if (valuesArrayErrors.length) {
          optionErrors.values = valuesArrayErrors;
          optionsArrayErrors[optionIndex] = optionErrors;
        }
      } else {
        if (option.values !== undefined && option.values.length === 0) {
          optionErrors.values = "Required";
          optionsArrayErrors[optionIndex] = optionErrors;
        }
      }
    });
    if (optionsArrayErrors.length) {
      errors.variant = { options: optionsArrayErrors };
    }
  }

  if (!values.shipping.free_shipping && !values.shipping.weight) {
    errors.shipping = { weight: ["Weight is required"] };
  }

  if (values.product_type === "Ticket" && !values.event.date) {
    errors.event = { date: ["Event date & time is required"] };
  }

  return errors;
};

export const validateProductEdit = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = ["Name is required"];
  }
  if (!values.brand) {
    errors.brand = ["Brand is required"];
  }
  if (!values.slug) {
    errors.slug = ["Slug is required"];
  }
  if (!values.payment_mode_id) {
    errors.payment_mode_id = ["Payment Mode is required"];
  }
  //remove validation because optional side group

  // if (!values.tags || !values.tags.length) {
  //   errors.tags = ["Tags is required"];
  // }
  //remove validation because optional side group
  // if (!values.collections || !values.collections.length) {
  //   errors.collections = ["Collections is required"];
  // }

  if (!values.shipping.free_shipping && !values.shipping.weight) {
    errors.shipping = { weight: ["Weight is required"] };
  }

  if (values.product_type === "Ticket" && !values.event.date) {
    errors.event = { date: ["Event date & time is required"] };
  }

  return errors;
};

export const checkSources = (props, sourceContains) => {
  if (props && props.dependsOn) {
    const sourceChildren = props.children.props.source;
    return sourceChildren.includes(sourceContains);
  }

  return props && props.source ? props.source.includes(sourceContains) : false;
};
export const checkSourcePhotos = (props, sourceContains) => {
  if (props && props.dependsOn) {
    const sourceChildren = props.children.props.source;
    return sourceChildren === sourceContains;
  }
  return false;
};

export const ProductFilter = ({ ...props }) => (
  <Filter {...props}>
    {(permissions) => [
      <TextInput
        label='resources.orders.actions.search'
        source='search'
        alwaysOn
      />,
      <SelectInput
        label='resources.products.fieldList.status'
        defaultValue={true}
        source='active'
        choices={[
          { id: true, name: "Active" },
          { id: false, name: "Inactive" },
        ]}
      />,
      permissions === "Admin" ? (
        <ReferenceInput
          label='resources.products.fieldList.account'
          source='account_id'
          reference='accounts'
        >
          <SelectInput optionText='name' />
        </ReferenceInput>
      ) : null,
      <ReferenceArrayInput
        label={"resources.products.fieldList.collections"}
        source='collections'
        reference='collections'
        allowEmpty
      >
        <SelectProductArrayInput optionText='name' />
      </ReferenceArrayInput>,
    ]}
  </Filter>
);

export const ProductsActions = ({
  resource,
  filters,
  displayedFilters,
  filterValues,
  basePath,
  showFilter,
  refresh,
}) => (
  <CardActions style={styles.cardActionStyleSmall} className='products-actions'>
    {filters &&
      React.cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: "button",
      })}
    <CreateButton basePath={basePath} />
    <RefreshButton basePath={basePath} refresh={refresh} />
    <ImportProductButton basePath={basePath} refresh={refresh} />
  </CardActions>
);



// WEBPACK FOOTER //
// ./src/products/defaultValues.js